<template>
  <div class="filter">
    <div class="filterContainer">
      <div class="mr10">
        <span class="w120 tar title">标题：</span>
        <a-input
          v-model:value="postParams.name"
          style="width: 220px;"
          placeholder="请输入标题"
          @change="
            e => inputLengthCut({ val: e.target.value, key: 'name', len: 255 })
          "
        />
      </div>
      <div class="mr10">
        <span class="w120 tar title">编码：</span>
        <a-input
          v-model:value="postParams.colId"
          style="width: 220px;"
          placeholder="请输入编码"
          @change="
            e => inputLengthCut({ val: e.target.value, key: 'colId', len: 10 })
          "
        />
      </div>
      <div class="mr10">
        <span class="w120 tar title">状态：</span>
        <a-select
          ref="select"
          v-model:value="postParams.status"
          style="width: 220px"
          :allowClear="true"
        >
          <a-select-option :value="-1">全部</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
          <a-select-option :value="1">启用</a-select-option>
        </a-select>
      </div>
    </div>
    <div class="filterContainer">
      <div class="mr10">
        <span class="w120 tar title">类型：</span>
        <a-select
          ref="select"
          v-model:value="postParams.colType"
          style="width: 220px"
          :allowClear="true"
        >
          <a-select-option :value="-1">全部</a-select-option>
          <a-select-option :value="0">手动</a-select-option>
          <a-select-option :value="1">自动</a-select-option>
        </a-select>
      </div>
      <div class="mr10">
        <span class="w120 tar title">Shopfiy对应ID：</span>
        <a-input
          v-model:value="postParams.shopifyColId"
          style="width: 220px;"
          placeholder="请输入Shopfiy对应ID"
          @change="
            e =>
              inputLengthCut({
                val: e.target.value,
                key: 'shopifyColId',
                len: 20
              })
          "
        />
      </div>
      <div class="mr10" v-if="open">
        <span class="w120 tar title">创建时间：</span>
        <a-range-picker
          style="width: 220px;"
          @change="e => changeFilterTime(e)"
          v-model:value="postParams.timeSet"
          show-time
          :placeholder="['开始时间', '结束时间']"
        />
      </div>
      <div class="mr10 tar" style="width: 360px;" v-if="!open">
        <a-button class="mr10" @click="() => resetParams()">重置</a-button>
        <a-button type="primary" @click="resetPagination">查询</a-button>
        <a-button type="link" @click="open = true"
          ><DownOutlined />展开</a-button
        >
      </div>
    </div>
    <div class="filterContainer" v-if="open">
      <div class="mr10">
        <span class="w120 tar title">创建人：</span>
        <a-input
          v-model:value="postParams.creatorName"
          style="width: 220px;"
          placeholder="请输入创建人"
          @change="
            e =>
              inputLengthCut({
                val: e.target.value,
                key: 'creatorName',
                len: 50
              })
          "
        />
      </div>
      <div class="mr10">
        <span class="w120 tar title">备注：</span>
        <a-input
          v-model:value="postParams.remark"
          style="width: 220px;"
          placeholder="请输入备注"
          @change="
            e =>
              inputLengthCut({ val: e.target.value, key: 'remark', len: 500 })
          "
        />
      </div>
      <div class="mr10">
        <span class="w120 tar title">人货场状态：</span>
        <a-select
          ref="select"
          v-model:value="postParams.peopleGoodsFlag"
          style="width: 220px"
          :allowClear="true"
        >
          <a-select-option :value="-1">全部</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
          <a-select-option :value="1">启用</a-select-option>
        </a-select>
      </div>
    </div>
    <div class="filterContainer" v-if="open">
      <div class="mr10">
        <span class="w120 tar title">是否促销专用：</span>
        <a-select
          ref="select"
          v-model:value="postParams.promotionFlag"
          style="width: 220px"
          :allowClear="true"
        >
          <a-select-option :value="-1">全部</a-select-option>
          <a-select-option :value="1">是</a-select-option>
          <a-select-option :value="0">否</a-select-option>
        </a-select>
      </div>
      <div class="mr10">
        <span class="w120 tar title">关联终端编码：</span>
        <a-input
          v-model:value="postParams.releationId"
          style="width: 220px;"
          placeholder="请输入关联终端编码"
        />
      </div>
      <div
        class="mr10"
        style="display: flex;justify-content: flex-start;flex-direction: column;"
      >
        <div>
          <span class="w120 tar title">SEO：</span>
          <a-input
            v-model:value="postParams.seoUrl"
            style="width: 220px;"
            placeholder="请输入seo链接"
            :maxlength="255"
          />
        </div>
        <a-checkbox
          style="margin-left: 120px;margin-top: 10px;"
          v-model:checked="extra"
          @change="e => (postParams.exact = e.target.checked ? 1 : 0)"
          >开启精准搜索</a-checkbox
        >
      </div>
    </div>
    <div class="filterContainer" v-if="open">
      <div class="mr10">
        <span class="w120 tar title">AB测试组名称：</span>
        <a-input
          v-model:value="postParams.testName"
          style="width: 220px;"
          :maxlength="255"
          placeholder="请输入AB测试组名称"
        />
      </div>
      <div class="mr10">
        <span class="w120 tar title">是否启用AB测试：</span>
        <a-select
          ref="select"
          v-model:value="postParams.enableTest"
          style="width: 220px"
          :allowClear="true"
        >
          <a-select-option :value="2">全部</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
          <a-select-option :value="1">启用</a-select-option>
        </a-select>
      </div>
      <div class="mr10">
        <span class="w120 tar title">混合子链接：</span>
        <a-select
          v-model:value="postParams.mixColFlag"
          style="width: 220px"
          placeholder="请选择"
          :allowClear="true"
        >
          <a-select-option :value="1">是</a-select-option>
          <a-select-option :value="0">否</a-select-option>
        </a-select>
      </div>
    </div>
    <div class="filterContainer" v-if="open">
      <div style="display: flex;flex-direction: row-reverse;">
        <div class="mr10 mb20 tar" style="width: 1060px;">
          <a-button class="mr10" @click="() => resetParams()">重置</a-button>
          <a-button type="primary" @click="resetPagination">查询</a-button>
          <a-button type="link" @click="open = false"
            ><UpOutlined />收起</a-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { inject, toRefs, reactive, watchEffect } from 'vue'
import { UpOutlined, DownOutlined } from '@ant-design/icons-vue'
export default {
  components: {
    UpOutlined,
    DownOutlined
  },
  setup() {
    const initData = inject('initState')
    const state = reactive({
      open: false,
      extra: false // 0 否 1 是
    })
    watchEffect(() => {
      state.extra = initData.postParams.exact === 1
    })
    return {
      ...toRefs(state),
      ...toRefs(initData)
    }
  }
}
</script>
<style scoped>
.filter {
  background: #ffffff;
}

.filterContainer {
  display: flex;
  flex-direction: row;
}

.filter .title {
  display: inline-block;
}
</style>
